/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';

export const WaveSurfer = ({
  children,
  onMount,
}: {
  children: React.ReactNode;
  onMount: (waveSurfer: $FIXME) => void;
}) => null;
export const WaveForm = ({ id, className }: { id: string; className: string }) => null;
